module.exports = __webpack_public_path__ + "static/media/mining_disabled.c80c420d.svg";